/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aichatcoverhellosubtitle4Inputs */

const en_aichatcoverhellosubtitle4 = /** @type {(inputs: Aichatcoverhellosubtitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify designs it with you, or you put the title and logo on your own photo.`)
};

const de_aichatcoverhellosubtitle4 = /** @type {(inputs: Aichatcoverhellosubtitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulsify entwirft es mit dir, oder du setzt Titel und Logo auf ein eigenes Foto.`)
};

/**
* | output |
* | --- |
* | "Pulsify designs it with you, or you put the title and logo on your own photo." |
*
* @param {Aichatcoverhellosubtitle4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aichatcoverhellosubtitle4 = /** @type {((inputs?: Aichatcoverhellosubtitle4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aichatcoverhellosubtitle4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aichatcoverhellosubtitle4(inputs)
	return de_aichatcoverhellosubtitle4(inputs)
});
export { aichatcoverhellosubtitle4 as "aiChatCoverHelloSubtitle" }